module.exports = __webpack_public_path__ + "static/assets/ee69bc3d5a7946a55b1e6174e2be9230.png";